import React, {Component} from 'react';
import {withApplicationContext} from "../../../contexts/ApplicationContext"
import {
    SliderContainer,
    GetStarted,
    GetStartedWrapper
} from "./style.jsx";
import {NavLink} from "react-router-dom";
import {ROUTE_TABLE_LIVE_PLAY} from "../../../routers/routes";

class Slider extends Component {
    render() {
        const {applicationContext} = this.props;
        return (
            <SliderContainer>
                <GetStarted>
                    <GetStartedWrapper>
                        <h1>{applicationContext.translator("Let's Play Live Roulette")}</h1>
                        <NavLink to={ROUTE_TABLE_LIVE_PLAY.concat("?lang="+applicationContext.state.lang)}>{applicationContext.translator("Play now")}</NavLink>
                    </GetStartedWrapper>
                </GetStarted>
            </SliderContainer>

        );
    }
}

export default withApplicationContext(Slider);